'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var _CheckBox = require('../CheckBox');
var _utilities = require('../../utilities');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ListPanelBase = function (_React$Component) {
  _inherits(ListPanelBase, _React$Component);
  function ListPanelBase(props) {
    _classCallCheck(this, ListPanelBase);
    var _this = _possibleConstructorReturn(this, (ListPanelBase.__proto__ || Object.getPrototypeOf(ListPanelBase)).call(this, props));
    _this.currentFocusedItem = null;
    _this.panelIsFocused = null;
    _this.selectedValue = [];
    _this.tabIndex = props.tabIndex || 8787;

    // highlight the selected value only if this is not a multiselect dropdown
    if (Array.isArray(props.selectedValue) === true) {
      _this.selectedValue = props.selectedValue;
      if (props.selectedValue.length === 1 && _this.props.multiselect !== true) {
        var index = _this.getIndexOfItem(props.data, props.selectedValue[0]);
        if (index !== null) {
          _this.currentFocusedItem = index;
        }
      }
    }
    var data = props.data;
    var selectAllChecked = data.filter(function (val) {
      return !val.disabled;
    }).length === _this.selectedValue.length;
    _this.state = {
      data: data,
      searchActive: false,
      selectAllChecked: selectAllChecked
    };
    _this.handleAddNewButtonClick = _this.handleAddNewButtonClick.bind(_this);
    _this.handleSearchBoxChange = _this.handleSearchBoxChange.bind(_this);
    _this.handleKeyDownOnItem = _this.handleKeyDownOnItem.bind(_this);
    _this.handleClickOnItem = _this.handleClickOnItem.bind(_this);
    _this.handleSearchBoxKeyDown = _this.handleSearchBoxKeyDown.bind(_this);
    _this.removeFocusFromSelectedItem = _this.removeFocusFromSelectedItem.bind(_this);
    _this.getIndexOfItem = _this.getIndexOfItem.bind(_this);
    _this.updateSelection = _this.updateSelection.bind(_this);
    _this.moveUpDown = _this.moveUpDown.bind(_this);
    _this.handleCheckBoxChange = _this.handleCheckBoxChange.bind(_this);
    _this.handleSelectAllChange = _this.handleSelectAllChange.bind(_this);
    _this.updateTopOffset = _this.updateTopOffset.bind(_this);
    _this.renderClearSelectedButton = _this.renderClearSelectedButton.bind(_this);
    _this.handleClearSelectedClicked = _this.handleClearSelectedClicked.bind(_this);
    return _this;
  }
  _createClass(ListPanelBase, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;
        if (Array.isArray(this.props.data) === true) {
          var id = this.props.id || _lodash2['default'].uniqueId('listPanel_');
          return _react2['default'].createElement('div', {
            id: id,
            name: 'listPanelContainer',
            className: this.props.className,
            tabIndex: this.tabIndex,
            style: {
              width: this.props.width,
              maxHeight: this.props.height
            },
            'data-component-parent': this.props.parentName,
            'data-internalid': this.props['data-internalid'],
            ref: function () {
              function ref(listPanelContainer) {
                _this2.listPanelContainerRef = listPanelContainer;
                _this2.props.setRef && _this2.props.setRef(listPanelContainer);
              }
              return ref;
            }()
          }, this.getSearchBox(), _react2['default'].createElement('div', {
            id: 'listPanelItemContainer',
            ref: function () {
              function ref(options) {
                _this2.options = options;
              }
              return ref;
            }(),
            'data-internalid': this.props['data-internalid']
          }, this.getDropDownListItems()));
        } else {
          return null;
        }
      }
      return render;
    }()

    /**
     * The selectedValue array can be updated by the app when a chip is deleted from the dropdown, the list needs to be updated in this case.
     * @param {object} newProps The updated props
     */
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        if (_lodash2['default'].isEqual(this.selectedValue, newProps.selectedValue) === false) {
          this.selectedValue = newProps.selectedValue;
          if (_lodash2['default'].isEqual(this.props.data, newProps.data) === false) {
            this.setState({
              data: newProps.data,
              selectAllChecked: this.selectedValue.length === this.state.data.length
            });
          } else {
            this.setState({
              selectAllChecked: this.selectedValue.length === this.state.data.length
            });
          }
        } else if (_lodash2['default'].isEqual(this.props.data, newProps.data) === false) {
          this.setState({
            data: newProps.data
          });
        } else if (_lodash2['default'].isEqual(this.props.data, newProps.data) === false) {
          this.setState({
            data: newProps.data
          });
        }
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.searchTextBox) {
          this.searchTextBox.focus();
        }
        this.updateSelection();
        this.panelIsFocused = true;
      }
      return componentDidMount;
    }()

    /**
     * This method is called from the reference to the ListPanel from the DropDownBase component.
     * @param {number} newOffset The top offset for the list panel.
     */
  }, {
    key: 'updateTopOffset',
    value: function () {
      function updateTopOffset(newOffset) {
        this.listPanelContainerRef.style.top = newOffset + 'px';
      }
      return updateTopOffset;
    }()
  }, {
    key: 'getIndexOfItem',
    value: function () {
      function getIndexOfItem(data, selectedValue) {
        var index = null;
        if (Array.isArray(data) === true) {
          for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (item[this.props.valuePropName] === selectedValue) {
              index = i;
              break;
            }
          }
        }
        return index;
      }
      return getIndexOfItem;
    }()

    /**
     * remove the 'selection' of the selected item when there is focus on the panel.
     */
  }, {
    key: 'removeFocusFromSelectedItem',
    value: function () {
      function removeFocusFromSelectedItem() {
        if (this.currentFocusedItem !== null) {
          var baseIndex = 0;
          if (this.props.addNewButtonText && this.props.addNewButtonText.length > 0) {
            baseIndex = 1;
          }
          if (this.options.children.length > 0) {
            this.options.children[this.currentFocusedItem + baseIndex].blur();
          }
          this.panelIsFocused = false;
          this.forceUpdate();
        }
      }
      return removeFocusFromSelectedItem;
    }()

    /**
     * Update the selection from the search results only when the dropdown is not multiselect
     */
  }, {
    key: 'updateSelection',
    value: function () {
      function updateSelection() {
        if (this.currentFocusedItem !== null && this.props.multiselect !== true) {
          var baseIndex = 0;
          if (this.props.addNewButtonText && this.props.addNewButtonText.length > 0) {
            baseIndex = 1;
          }
          if (this.options && this.options.children && this.options.children.length > baseIndex) {
            this.options.children[this.currentFocusedItem + baseIndex].focus();
          }
          if (this.state.data && this.state.data.length > 0) {
            this.selectedValue = [this.state.data[this.currentFocusedItem][this.props.valuePropName]];
          }
          if (this.searchTextBox) {
            this.searchTextBox.focus();
          }
          this.forceUpdate();
        }
      }
      return updateSelection;
    }()
  }, {
    key: 'moveUpDown',
    value: function () {
      function moveUpDown(keyCode, e, nativeEvent) {
        var ENTER_KEY_CODE = 13;
        var DOWN_ARROW_KEY_CODE = 40;
        var UP_ARROW_KEY_CODE = 38;
        // const ESC_KEY_CODE = 27;
        var baseIndex = 0;

        // we need the baseIndex to account for the add new button which is not navigated
        // using the keyboard.
        if (this.props.addNewButtonText && this.props.addNewButtonText.length > 0) {
          baseIndex = 1;
        }
        if (keyCode == DOWN_ARROW_KEY_CODE) {
          if (this.currentFocusedItem + baseIndex === this.options.children.length - 1) {
            return;
          }
          this.currentFocusedItem++;
          this.options.children[this.currentFocusedItem + baseIndex].focus();
          if (this.props.multiselect !== true) {
            this.selectedValue.push(this.state.data[this.currentFocusedItem][this.props.valuePropName]);
            if (typeof this.props.changeHandler === 'function') {
              this.props.changeHandler(this.selectedValue);
            }
          }
          this.forceUpdate();
        }
        if (keyCode == UP_ARROW_KEY_CODE) {
          if (this.currentFocusedItem === 0) {
            return;
          }
          this.currentFocusedItem--;
          this.options.children[this.currentFocusedItem + baseIndex].focus();
          if (this.props.multiselect !== true) {
            this.selectedValue.push(this.state.data[this.currentFocusedItem][this.props.valuePropName]);
            if (typeof this.props.changeHandler === 'function') {
              this.props.changeHandler(this.selectedValue);
            }
          }
          this.forceUpdate();
        }
        if (keyCode === ENTER_KEY_CODE) {
          if (this.props.multiselect === true) {
            // just toggle the checkbox and update the selectedValue variable
          } else {
            if (typeof this.props.selectionConfirmedHandler === 'function') {
              this.props.selectionConfirmedHandler(this.selectedValue, e, nativeEvent);
            }
          }
        }
      }
      return moveUpDown;
    }()
  }, {
    key: 'handleKeyDownOnItem',
    value: function () {
      function handleKeyDownOnItem(e) {
        this.moveUpDown(e.keyCode, e, e.nativeEvent);
        // need this prevent default to stop the scroll bar from moving all the time
        e.preventDefault();
      }
      return handleKeyDownOnItem;
    }()

    /**
     * We will only handle the arrow down event for the search box.
     * @param {object} e The synthetic event
     */
  }, {
    key: 'handleSearchBoxKeyDown',
    value: function () {
      function handleSearchBoxKeyDown(e) {
        var DOWN_ARROW_KEY_CODE = 40;
        if (e.keyCode === DOWN_ARROW_KEY_CODE) {
          this.moveUpDown(e.keyCode, e);
        }
      }
      return handleSearchBoxKeyDown;
    }()
  }, {
    key: 'handleClickOnItem',
    value: function () {
      function handleClickOnItem(e) {
        var dataIndex = parseInt(e.currentTarget.dataset.index);
        this.selectedValue = []; // empty the array
        this.selectedValue.push(this.state.data[dataIndex][this.props.valuePropName]);
        if (typeof this.props.selectionConfirmedHandler === 'function') {
          this.props.selectionConfirmedHandler(this.selectedValue, e, e.nativeEvent);
        }
      }
      return handleClickOnItem;
    }()

    /**
     * Handler for the checkbox click, add the item to the selected values if the checkbox is checked
     * else remove the item from the selected values.
     * @param {*} e
     */
  }, {
    key: 'handleCheckBoxChange',
    value: function () {
      function handleCheckBoxChange(isChecked, value, e) {
        var _this3 = this;

        // let dataIndex = parseInt(e.currentTarget.dataset.index);
        if (isChecked === true) {
          // add the value to the selected items
          this.selectedValue.push(value);
        } else {
          // remove the value from the selected items
          _lodash2['default'].remove(this.selectedValue, function (val) {
            return val === value;
          });
          this.selectedValue = this.selectedValue;
        }
        var isSelectAllChecked = false;
        // get filtered data based on disabled prop name, if an item is disabled it should not count towards the length
        var disabledPropName = this.props.disabledPropName;
        var enabledData = _lodash2['default'].filter(this.state.data, function (item) {
          if (disabledPropName) {
            return item[disabledPropName] !== true;
          } else {
            return true; // return all values if there is no disabledPropName defined
          }
        });

        if (enabledData.length === this.selectedValue.length) {
          isSelectAllChecked = true;
        }
        this.setState({
          selectAllChecked: isSelectAllChecked
        }, function () {
          if (typeof _this3.props.selectionConfirmedHandler === 'function') {
            _this3.props.selectionConfirmedHandler(_this3.selectedValue, e);
          }
        });
      }
      return handleCheckBoxChange;
    }()
  }, {
    key: 'handleAddNewButtonClick',
    value: function () {
      function handleAddNewButtonClick(e) {
        if (typeof this.props.addNewButtonClickHandler === 'function') {
          this.props.addNewButtonClickHandler(e);
        }
      }
      return handleAddNewButtonClick;
    }()
  }, {
    key: 'handleSearchBoxChange',
    value: function () {
      function handleSearchBoxChange(e) {
        var _this4 = this;
        var searchTerm = e.target.value == null || e.target.value == undefined ? '' : e.target.value;
        searchTerm = searchTerm.toLowerCase();
        var self = this;
        var includes = function () {
          function includes(searchString, searchTerm, start) {
            if (typeof start !== 'number') {
              start = 0;
            }
            if (start + searchTerm.length > _this4.length) {
              return false;
            } else {
              return searchString.indexOf(searchTerm, start) !== -1;
            }
          }
          return includes;
        }();
        if (searchTerm.length > 0) {
          var searchResult = [];
          _lodash2['default'].each(self.props.data, function (item) {
            if (includes(item[self.props.textPropName].toLowerCase(), searchTerm) === true) {
              searchResult.push(item);
            }
          });
          self.setState({
            data: searchResult,
            searchActive: true
          }, function () {
            self.currentFocusedItem = 0;
            self.updateSelection();
          });
        } else {
          self.setState({
            data: self.props.data,
            searchActive: false
          }, function () {
            self.currentFocusedItem = 0;
            self.updateSelection();
          });
        }
      }
      return handleSearchBoxChange;
    }()

    /**
     * To support IE's clear button, we listen to the onInput event instead if the onChange event, as onChange is not fired for the clear button.
     * We still need to specify a handler the onChange event otherwise there will be browser warning.
     * @param {*} e
     */
  }, {
    key: 'handleSearchBoxChangeDummy',
    value: function () {
      function handleSearchBoxChangeDummy() {}
      return handleSearchBoxChangeDummy;
    }()
  }, {
    key: 'getAddNewButton',
    value: function () {
      function getAddNewButton() {
        return _react2['default'].createElement('div', {
          name: 'listPanelOption',
          id: 'addNewButton',
          key: 'addNewButton',
          tabIndex: this.tabIndex + 1,
          onClick: this.handleAddNewButtonClick
        }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faPlusCircle
        }), _react2['default'].createElement('span', null, (0, _utilities.getLabel)(this.props.labels, 'addNewButtonText')));
      }
      return getAddNewButton;
    }()
  }, {
    key: 'renderSelectAll',
    value: function () {
      function renderSelectAll() {
        return _react2['default'].createElement('div', {
          name: 'listPanelOption-selectAll',
          key: 'selectAllCheckBox',
          tabIndex: this.tabIndex + 2,
          onMouseOver: this.removeFocusFromSelectedItem,
          'data-internalid': this.props['data-internalid']
        }, _react2['default'].createElement(_CheckBox.CheckBox, {
          label: this.getSelectAllText(),
          'data-internalid': this.props['data-internalid'],
          checked: this.state.selectAllChecked,
          changeHandler: this.handleSelectAllChange
        }));
      }
      return renderSelectAll;
    }()

    /**
     * Function to get the text for the select all checkbox. When search is not active, return the select all text + count of items
     * When search is active return select results text + count of items
     */
  }, {
    key: 'getSelectAllText',
    value: function () {
      function getSelectAllText() {
        if (this.state.searchActive === false) {
          return (0, _utilities.getLabel)(this.props.labels, 'selectAllText') + ' (' + this.state.data.length + ')';
        } else {
          return (0, _utilities.getLabel)(this.props.labels, 'selectResultsText') + ' (' + this.state.data.length + ')';
        }
      }
      return getSelectAllText;
    }()
  }, {
    key: 'handleSelectAllChange',
    value: function () {
      function handleSelectAllChange(isChecked) {
        var _this5 = this;
        var valuePropName = this.props.valuePropName;
        var disabledPropName = this.props.disabledPropName;
        if (isChecked === true) {
          // When 'Select All' is checked, we want to add all the items from state.data
          // that are not in the selectedValue array to the selectedValue array, because
          // some items from state.data may already be in the selectedValue array and we
          // do not want to duplicate whats in the selectedValue array.
          // So find the difference and then add that difference to the selectedValue array.
          // Send this difference as a parameter to the selectAllChangeHandler function.

          // first get the list of all 'values' from state.data that *can* be selected
          // ignore the disabled values
          var enabledData = _lodash2['default'].filter(this.state.data, function (item) {
            if (disabledPropName) {
              return item[disabledPropName] !== true;
            } else {
              return true; // return all values if there is no disabledPropName defined
            }
          });

          var dataValues = _lodash2['default'].map(enabledData, valuePropName);
          // Now find the difference between the dataValues and the selectedValue array.
          var toAddValues = _lodash2['default'].difference(dataValues, this.selectedValue);
          // merge the toAddValues into selectedValue array
          this.selectedValue = _lodash2['default'].concat(this.selectedValue, toAddValues);
          this.setState({
            selectAllChecked: isChecked
          }, function () {
            if (typeof _this5.props.selectAllChangeHandler === 'function') {
              _this5.props.selectAllChangeHandler(isChecked, toAddValues);
            }
          });
        } else {
          // The results might be partial because a search has been performed, only remove
          // the items from the selectedValue list that are in the state.data array

          // first get the list of all 'values' from state.data
          // ignore the disabled values
          var _enabledData = _lodash2['default'].filter(this.state.data, function (item) {
            if (disabledPropName) {
              return item[disabledPropName] !== true;
            } else {
              return true; // return all values if there is no disabledPropName defined
            }
          });

          var _dataValues = _lodash2['default'].map(_enabledData, valuePropName);
          // Now find the difference between the dataValues and the selectedValue array.
          this.selectedValue = _lodash2['default'].difference(this.selectedValue, _dataValues);
          this.setState({
            selectAllChecked: isChecked
          }, function () {
            // return all the values from the state.data array so that they can be removed by the app
            if (typeof _this5.props.selectAllChangeHandler === 'function') {
              _this5.props.selectAllChangeHandler(isChecked, _dataValues);
            }
          });
        }
      }
      return handleSelectAllChange;
    }()

    /**
     * Function that renders the group header if the data defines a group header and
     * renders the 'Clear Selected' button if defined in the labels.
     */
  }, {
    key: 'renderGroupHeader',
    value: function () {
      function renderGroupHeader(key, groupName) {
        return _react2['default'].createElement('div', {
          name: 'listPanelGroupContainer',
          key: key
        }, _react2['default'].createElement('div', {
          name: 'listPanelGroupOption',
          title: groupName
        }, groupName), this.renderClearSelectedButton());
      }
      return renderGroupHeader;
    }()

    /**
     * Function to render the clear selected button if the label exists.
     */
  }, {
    key: 'renderClearSelectedButton',
    value: function () {
      function renderClearSelectedButton() {
        if ((0, _utilities.labelExists)(this.props.labels, 'clearSelectedLabel') > 0) {
          return _react2['default'].createElement('div', {
            name: 'listPanelClearSelected',
            onClick: this.handleClearSelectedClicked,
            'data-internalid': this.props['data-internalid'],
            title: this.props.labels.clearSelectedLabel
          }, this.props.labels.clearSelectedLabel);
        } else {
          return null;
        }
      }
      return renderClearSelectedButton;
    }()

    /**
     * Function called when the Clear Selected button is clicked.
     * Reset the selected values to an empty array and trigger the call to the filter changed handler.
     * @param {object} e The click event object.
     */
  }, {
    key: 'handleClearSelectedClicked',
    value: function () {
      function handleClearSelectedClicked(e) {
        this.selectedValue = [];
        if (typeof this.props.selectionConfirmedHandler === 'function') {
          this.props.selectionConfirmedHandler(this.selectedValue, e);
        }
      }
      return handleClearSelectedClicked;
    }()
  }, {
    key: 'getDropDownListItems',
    value: function () {
      function getDropDownListItems() {
        var _this6 = this;
        var options = [];
        if ((0, _utilities.labelExists)(this.props.labels, 'addNewButtonText')) {
          // add new button exists
          options.push(this.getAddNewButton());
        }

        // add the Select All checkbox only if the text for it is provided and there is data to list
        if ((0, _utilities.labelExists)(this.props.labels, 'selectAllText') > 0 && this.state.data.length > 0 && this.props.multiselect === true) {
          // select all checkbox exists
          options.push(this.renderSelectAll());
        }
        // Add a group item if specified via the groupName key value pair.
        var groupName = null;
        options = options.concat(this.state.data.map(function (item, index) {
          var optionsGroup = [];
          if (item.groupName && item.groupName.length > 0 && item.groupName != groupName) {
            // add a div for groupname
            optionsGroup.push(_this6.renderGroupHeader('optionGroup' + index, item.groupName));
            groupName = item.groupName;
          }
          if (_this6.props.multiselect === true) {
            var isChecked = false;
            for (var _index = 0; _index <= _this6.selectedValue.length; _index++) {
              if (_this6.selectedValue[_index] === item[_this6.props.valuePropName]) {
                isChecked = true;
                break;
              }
            }
            if (optionsGroup.length > 0) {
              optionsGroup.push(_react2['default'].createElement('div', {
                name: 'listPanelOption',
                key: 'option' + index,
                tabIndex: _this6.tabIndex + 3 + index + 1,
                onKeyDown: _this6.handleKeyDownOnItem,
                onMouseOver: _this6.removeFocusFromSelectedItem,
                'data-internalid': _this6.props['data-internalid'],
                title: item[_this6.props.textPropName]
              }, _react2['default'].createElement(_CheckBox.CheckBox, {
                label: item[_this6.props.textPropName],
                value: item[_this6.props.valuePropName],
                changeHandler: _this6.handleCheckBoxChange,
                checked: isChecked,
                disabled: item[_this6.props.disabledPropName]
              })));
              return optionsGroup;
            } else {
              return _react2['default'].createElement('div', {
                name: 'listPanelOption',
                key: 'option' + index,
                tabIndex: _this6.tabIndex + 3 + index + 1,
                onKeyDown: _this6.handleKeyDownOnItem,
                onMouseOver: _this6.removeFocusFromSelectedItem,
                'data-internalid': _this6.props['data-internalid'],
                title: item[_this6.props.textPropName]
              }, _react2['default'].createElement(_CheckBox.CheckBox, {
                label: item[_this6.props.textPropName],
                value: item[_this6.props.valuePropName],
                changeHandler: _this6.handleCheckBoxChange,
                checked: isChecked,
                disabled: item[_this6.props.disabledPropName]
              }));
            }
          } else {
            var isDisabled = item[_this6.props.disabledPropName];
            if (optionsGroup.length > 0) {
              optionsGroup.push(_react2['default'].createElement('div', {
                name: 'listPanelOption',
                key: 'option' + index,
                tabIndex: _this6.tabIndex + 2 + index + 1,
                onKeyDown: _this6.handleKeyDownOnItem,
                onClick: isDisabled ? null : _this6.handleClickOnItem,
                onMouseOver: _this6.removeFocusFromSelectedItem,
                'data-index': index,
                title: item[_this6.props.textPropName],
                'data-internalid': _this6.props['data-internalid'],
                className: isDisabled ? 'listPanelOption-disabled' : null
              }, item[_this6.props.textPropName]));
              return optionsGroup;
            } else {
              return _react2['default'].createElement('div', {
                name: 'listPanelOption',
                key: 'option' + index,
                tabIndex: _this6.tabIndex + 2 + index + 1,
                onKeyDown: _this6.handleKeyDownOnItem,
                onClick: isDisabled ? null : _this6.handleClickOnItem,
                onMouseOver: _this6.removeFocusFromSelectedItem,
                'data-index': index,
                title: item[_this6.props.textPropName],
                'data-internalid': _this6.props['data-internalid'],
                className: isDisabled ? 'listPanelOption-disabled' : null
              }, item[_this6.props.textPropName]);
            }
          }
        }));
        return options;
      }
      return getDropDownListItems;
    }()
  }, {
    key: 'getSearchBox',
    value: function () {
      function getSearchBox() {
        var _this7 = this;

        // dont show the search box for the mini size because it is too small
        if (this.props.searchBox === true && this.props.size !== 'xSmall') {
          return _react2['default'].createElement('div', {
            id: 'searchBoxContainer',
            'data-internalid': this.props['data-internalid']
          }, _react2['default'].createElement('div', {
            id: 'searchBox',
            tabIndex: this.tabIndex + 1,
            'data-internalid': this.props['data-internalid']
          }, _react2['default'].createElement('div', null, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _freeSolidSvgIcons.faSearch
          })), _react2['default'].createElement('input', {
            type: 'text',
            id: 'searchTextBox',
            name: 'searchTextBox',
            tabIndex: this.tabIndex + 1,
            onInput: this.handleSearchBoxChange,
            onChange: this.handleSearchBoxChangeDummy,
            ref: function () {
              function ref(searchTextBox) {
                _this7.searchTextBox = searchTextBox;
              }
              return ref;
            }(),
            onKeyDown: this.handleSearchBoxKeyDown,
            'data-internalid': this.props['data-internalid']
          })));
        }
      }
      return getSearchBox;
    }()
  }]);
  return ListPanelBase;
}(_react2['default'].Component);
exports['default'] = ListPanelBase;
ListPanelBase.defaultProps = {
  selectedValue: []
};